<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать опрос</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyUpsertForm
                        @success="$router.push(`/surveys`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyUpsertForm from '@/components/surveys/SurveyUpsertForm';

    export default {
        name: 'SurveyCreate',

        components: {
            SurveyUpsertForm
        },
    };
</script>
